export default {"src":"/_next/static/media/icon-laugh.5bb60557.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};